// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs";

// Wrap Turbo import to prevent double-registration errors
try {
  if (!window.Turbo) {
    require("@hotwired/turbo-rails");
  }
} catch (e) {
  // Turbo already loaded, ignore the error
  console.warn('Turbo registration skipped:', e.message);
}

import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "../modules/theme-toggler";
import "../modules/network-health-monitor";
import "../modules/frontend-performance-monitor";

// Import images so they're included in the asset pipeline
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

// Load jQuery and DataTables FIRST before any other scripts
global.$ = global.jQuery = require("jquery");
require("datatables.net");
require("datatables.net-dt");

// Start Rails UJS and ActiveStorage (only once)
// Wrap in try-catch to prevent double-loading errors
try {
  Rails.start();
} catch (e) {
  // Rails UJS already loaded, ignore the error
  if (!e.message.includes('already been loaded')) {
    throw e;
  }
}

try {
  ActiveStorage.start();
} catch (e) {
  // ActiveStorage already loaded, ignore the error
  console.warn('ActiveStorage start skipped:', e.message);
}

// Import page-specific scripts AFTER jQuery is loaded
import "./src/users";
import "./src/stations";
import "./src/markets";
import "./src/logs";
import "./src/voicetracks";
import "./src/voicetrack_interface";

document.addEventListener("turbo:load", function() {
  setTimeout(function() {
    $("#flash-messages").hide();
  }, 5000);
});

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);

application.load(definitionsFromContext(context));

// Import and register all TailwindCSS Components
import {
  Alert,
  Autosave,
  Dropdown,
  Modal,
  Tabs,
  Popover,
  Toggle,
  Slideover
} from "tailwindcss-stimulus-components";
application.register("alert", Alert);
application.register("autosave", Autosave);
application.register("dropdown", Dropdown);
application.register("modal", Modal);
application.register("tabs", Tabs);
application.register("popover", Popover);
application.register("toggle", Toggle);
application.register("slideover", Slideover);
